export default __webpack_public_path__ + "static/media/marine.ecab64ce.jpg";